export default __webpack_public_path__ + "static/media/acnescarp.9493fe10.pdf";